import { SUBSCRIPTION_TYPE_DEMO } from '@/modules/base/util/constants'

/**
 * A demo tenant owns a regular, non-trial subscription of type "demo" with typeOfSubscription "main".
 * In the shop it must not count as an existing purchase: otherwise the plans render the upgrade
 * buttons instead of the buy buttons, and the upgrade links need a license serial the demo tenant
 * does not have.
 */
export const withoutDemoSubscription = <T extends { type: string }>(subscriptions: T[] = []) => subscriptions.filter(subscription => subscription.type !== SUBSCRIPTION_TYPE_DEMO)
